module.exports = __webpack_public_path__ + "static/media/thumbnail.05e6bcc0.jpg";